import { render, staticRenderFns } from "./Subscription.vue?vue&type=template&id=3bb21054&scoped=true"
import script from "./Subscription.vue?vue&type=script&lang=ts"
export * from "./Subscription.vue?vue&type=script&lang=ts"
import style0 from "./Subscription.vue?vue&type=style&index=0&id=3bb21054&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb21054",
  null
  
)

export default component.exports